import * as React from "react";
import MUITabs from "@mui/material/Tabs";
import MUITab from "@mui/material/Tab";
import MUIBox from "@mui/material/Box";
import SC from "./style";
import useIsMobile from "customHook/useIsMobile";

function Tabs(props) {
  const { value, label, onChange, selectedValue, children, sx } = props;
  const isMobile = useIsMobile();

  return (
    <>
      <SC.GlobalStyles />
      <MUIBox
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: isMobile ? "column" : "row", // stack on desktop if needed
          alignItems: isMobile ? "flex-start" : "center",
        }}
      >
        <MUITabs
          value={selectedValue}
          onChange={onChange}
          orientation={isMobile ? "vertical" : "horizontal"} // horizontal on mobile
          sx={{
            ...(isMobile ? { width: "100%" } : { minWidth: 150 }), // optional min width for vertical tabs
            ...sx,
          }}
        >
          {label?.map((itemLabel, index) => (
            <MUITab
              key={index}
              value={value[index]}
              label={itemLabel}
              sx={{
                textTransform: "capitalize",
                ...(isMobile && { width: "100%", textAlign: "center" }),
                ...sx,
              }}
            />
          ))}
        </MUITabs>
        {children && <MUIBox sx={{ flex: 1 }}>{children}</MUIBox>}
      </MUIBox>
    </>
  );
}

export default Tabs;
